import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    data: {
      color: "black",
      marginRight: "2.88vh",
    },
    dataMobile: {
      color: "black",
    },
    list: {
      display: "inline-grid",
      justifyContent: "right",
      marginTop: "0px",
      marginBottom: "0px",
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    listItem: {
      paddingTop: "0px",
      paddingBottom: "0px",
      right: "1vw",
      top: "0.5vh",
    },
    noPadding: {
      padding: 0,
    },
    userInfo: {
      paddingBlock: 0,
      paddingInline: 10,
      direction: "rtl",
    },
    listUserInfo: {
      paddingTop: "3vh",
      paddingBottom: "1vh",
      paddingRight: "6vw",
      paddingLeft: "2vw",
    },
    paddingX: {
      paddingInline: "10px",
    },
    avatar: {
      width: "8vh",
      heigh: "3.6vw",
    },
    large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
  })
);
